export const getAuthProfile = state => state.auth.authProfile;
export const getSecondData = state => state.auth.secondData;
